import { customAlphabet } from 'nanoid/non-secure';
import { isServer } from './ssr';

enum StorageKeys {
  machineId = 'common.machineId',
  commonDeviceId = 'common.projectCid',
}

let cid: string | undefined = undefined;

// 原名为 getDeviceId【混淆命名，增加破解难度】
export function getCid() {
  if (isServer) {
    return cid;
  }
  if (cid) {
    return cid;
  }

  const nanoid = customAlphabet(
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
    32,
  );

  cid = localStorage.getItem(StorageKeys.commonDeviceId) ?? undefined;

  // 获取旧数据
  if (!cid) {
    const oldCid = localStorage.getItem(StorageKeys.machineId);
    if (oldCid) {
      cid = oldCid;
      localStorage.setItem(StorageKeys.commonDeviceId, cid);
    }
  }
  if (!cid) {
    const newNanoid = nanoid();
    cid = [
      newNanoid.slice(0, 8),
      newNanoid.slice(8, 12),
      newNanoid.slice(12, 16),
      newNanoid.slice(16, 20),
      newNanoid.slice(20, 32),
    ].join('-');
    localStorage.setItem(StorageKeys.commonDeviceId, cid);
  }
  return cid;
}
